









import { Component, Mixins } from "vue-property-decorator";

import ModalComponent from "@service/components/modal/ModalComponent.vue";
import SegmentControl from  "@share/common/segment/Segment.vue";

import PostRegistraion from "@share/auth-anonym/components/PostRegistraion.vue";
import LoginForm from "@share/auth-anonym/components/LoginForm.vue";
import { ConfigurationRepository } from "@api/repositories/ConfigurationRepository";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { getBackend } from "@service/router/getters";
import { UserRepository } from "@api/repositories/UserRepository";
import AuthFormProcessor from "@share/auth/AuthFormProcessor.vue";
import LoginLogic from "@share/auth/LoginLogic.vue";

@Component({ components: { ModalComponent, SegmentControl, PostRegistraion, LoginForm } })

export default class AuthAnonym extends Mixins(AuthFormProcessor, LoginLogic) {

    userRepository: UserRepository = this.$repositories.get(RepositoryFabric.USER);
    configurationRepository: ConfigurationRepository | null;

    created() {
        this.configurationRepository = this.$repositories.get(RepositoryFabric.CONFIGURATION);
    }

    async mounted() {
        const configuration = await this.configurationRepository?.appropriateConfiguration('Web');
        configuration && this.processForm(configuration);
    }

    //pass session to parent component
    async login(session: string) {
        try {
            const sessionObject = JSON.parse(session);
            if (sessionObject) {
                sessionObject.backend = getBackend(this.$route.params.backend);
                await this.loggedIn(sessionObject);

                this.$emit('close')
            }
        }
        catch (e) {
            console.log(e, 'Неверный объект');
        }
    }
}

